import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import {
  library
} from "@fortawesome/fontawesome-svg-core";
import {
  faAndroid,
  faApple,
  faAws,
  faJsSquare,
  faNode,
  faPhp,
  faCss3,
  faHtml5,
  faGitSquare,
  faEthereum,
  faLess,
  faSass,
  faSwift,
  faWordpress,
  faVuejs,
  faReact,
  faBitcoin,
  faDocker,
  faBluetooth
} from "@fortawesome/free-brands-svg-icons";
import {
  FontAwesomeIcon
} from "@fortawesome/vue-fontawesome";

library.add(faAndroid,
  faApple,
  faAws,
  faJsSquare,
  faNode,
  faPhp,
  faCss3,
  faHtml5,
  faGitSquare,
  faEthereum,
  faLess,
  faSass,
  faSwift,
  faWordpress,
  faVuejs,
  faReact,
  faBitcoin,
  faDocker,
  faBluetooth
);
Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.config.productionTip = false
import VueAgile from 'vue-agile';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
Vue.use(VueAwesomeSwiper, /* { default global options } */ );
Vue.use(VueAgile);
new Vue({
  vuetify,
  render: h => h(App)
}).$mount('#app')